<template>
  <nav>
    <div class="container">
      <ul>
        <router-link :to="{name: 'Players'}" tag="li">Работа с участниками</router-link>
        <router-link :to="{name: 'PlayersOnline'}" tag="li">Участники онлайн</router-link>
        <router-link :to="{name: 'Groups'}" tag="li">Работа с группами</router-link>
        <router-link :to="{name: 'Tests'}" tag="li">Работа с программами</router-link>
      </ul>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'Nav'
  }
</script>

<style scoped lang="scss">
  nav{
    border-bottom: 1px solid #e6e6e6;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    .router-link-exact-active, .router-link-active{
      color: #0063B0;
    }
    li{
      display: inline-block;
      padding: 20px 0;
      margin-right: 40px;
      color: #808080;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Nav.vue